import { action } from 'mobx';
import { BaseFormStore, authStore } from 'stores';
import { authService } from 'common/security';

class LoginStore extends BaseFormStore {	
	constructor() {
		super();
		this.initializeForm();
	}

	initializeForm() {
		this.form.fields = {
			email: {
				value: '',
				error: null,
				rule: 'required|email'
			},
			password: {
				value: '',
				error: null,
				rule: 'required'
			},
		};

		this.form.meta = {
			isValid: true,
			error: null
		};
	}

	@action
    async login(username, password) {
		this.setError(null);
		this.setLoading(true);

        try {
            var response = await authService.authenticate(username, password);
            const token = await response.json();
			authStore.setSession(token);
			await authStore.loadUser();
        } catch(ex) {
			const { response } = ex;
			var errorMessage = 'Something went wrong while we tried to log you in. Please try again.';
			if (response) {
				var errorResponse = await response.json();
            
				if (response.status === 400 && errorResponse.error === 'invalid_grant') {
					errorMessage = 'Invalid username or password'
				}
			}            

			this.setError(errorMessage);			
		}

		this.setLoading(false);
	}

	@action
    logout() {
		authStore.removeSession();
    }
}

const loginStore = new LoginStore();
export { loginStore }


// WEBPACK FOOTER //
// ./src/modules/login/loginStore.js